module.exports = __webpack_public_path__ + "static/media/RHE56M.6a2a24d5.jpg";